/**
 * Created by Maxim B. on 10/04/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'curr-red-label',
  templateUrl: './red-label.component.html',
  styleUrls: ['./red-label.component.scss']
})
export class RedLabelComponent implements OnInit {

  @Input() text: string;

  constructor() { }

  ngOnInit(): void {
  }

}
